export const mandatoryBundleParams = Object.freeze({
  visibleOnWeb: true,
  active: true,
  published: true,
});
